const hasOpenTokSupport = require('./hasOpenTokSupport.js').once;

// Indicates if the browser supports RTCP Mux
//
// Broadly:
// * All recent versions of WebRTC (both Chrome and Firefox) support RtcpMux

module.exports = () => hasOpenTokSupport();
